import axios from 'axios';
import { applyMiddleware, compose, createStore } from 'redux';
import { withExtraArgument } from 'redux-thunk';

import env from '../env';
import reducer from '../reducers';

export const axiosConfig = {
    baseURL: env.REACT_APP_SERVICE_API_URL,
    timeout: 60000,
};

export const axiosInstance = axios.create(axiosConfig);

let middlewares = [
    withExtraArgument({
        axios: axiosInstance,
    }),
];

// Adds middlewares to Client side only
if (typeof window !== 'undefined' && window.document && window.document.createElement) {
    middlewares = [...middlewares];
}

const configureStore = initialState => {
    const enhancers = compose(
        // Middleware store enhancer.
        applyMiddleware(
            // Initialising redux-thunk with extra arguments will pass the below
            // arguments to all the redux-thunk actions. Below we are passing a
            // preconfigured axios instance which can be used to fetch data with.
            // @see https://github.com/gaearon/redux-thunk
            ...middlewares
        ),
        // Redux Dev Tools store enhancer.
        // @see https://github.com/zalmoxisus/redux-devtools-extension
        // We only want this enhancer enabled for development and when in a browser
        // with the extension installed.
        process.env.NODE_ENV === 'development' &&
            typeof window !== 'undefined' &&
            typeof window.__REDUX_DEVTOOLS_EXTENSION__ !== 'undefined'
            ? // Call the brower extension function to create the enhancer.
              window.__REDUX_DEVTOOLS_EXTENSION__()
            : // Else we return a no-op function.
              f => f
    );

    const store = initialState
        ? createStore(reducer, initialState, enhancers)
        : createStore(reducer, enhancers);

    if (process.env.NODE_ENV === 'development' && import.meta.hot) {
        // Enable Webpack hot module replacement for reducers. This is so that we
        // don't lose all of our current application state during hot reloading.
        import.meta.hot.accept('../reducers', newReducers => {
            store.replaceReducer(newReducers.default);
        });
    }

    return store;
};

export default configureStore;
